import React, { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import AboutUs from './AboutUs';
import NewsletterAndFeaturesSection from './NewsLetterSection';
import ProductSection from './ProductSection';
import PricingSection from './PricingSection';
import PartnersSection from './PartnersSection';
import FAQSections from './FAQSections';
import LiveApplicationsCarousel from './LiveApplicationsCarousel';
import ContactSection from './ContactSection';
import FeaturesSection from './FeaturesSection';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import config from '../config';

export default function HomeComponent() {
  const [countryCode, setCountryCode] = useState("");

  const validationSchema = Yup.object({
    businessName: Yup.string()
      .trim()
      .required('Business Name is required')
      .test('no-whitespace', 'Business Name cannot be just spaces', value => value && value.trim().length > 0),
    businessType: Yup.string()
      .trim()
      .required('Business Type is required')
      .test('no-whitespace', 'Business Type cannot be just spaces', value => value && value.trim().length > 0),
    businessEmail: Yup.string()
      .email('Invalid email address')
      .required('Email is required')
      .test('no-whitespace', 'Email cannot be just spaces', value => value && value.trim().length > 0),
    businessPhone: Yup.string()
      .trim()
      .required('Phone number is required')
      .test('no-whitespace', 'Phone number cannot be just spaces', value => value && value.trim().length > 0),
    description: Yup.string()
      .trim()
      .test('no-whitespace', 'Description cannot be just spaces', value => value && value.trim().length > 0),
  });

  const { values, handleChange, handleSubmit, isSubmitting, errors, touched, setFieldValue,resetForm } = useFormik({
    initialValues: {
      businessName: '',
      businessType: '',
      businessEmail: '',
      businessPhone: '',
      description: '',
    },
    validationSchema,
 
    onSubmit: async (values) => {
      const api = config.apiBaseUrl;
    
      const requestBody = {
        business_name: values.businessName,
        business_type: values.businessType,
        business_email: values.businessEmail,
        business_phone: '+'+values.businessPhone,
        description: values.description,
      };
      try {

        const response = await axios.post(`${api}request-demo/`, requestBody);
        if (response.data && response.data.status === 1) {
          resetForm();
          toast.success(response.data.message || 'Thank you for your request! We will get back to you soon.');
        } else {
          toast.error(response.data.message || 'Something went wrong! Please try again.');
        }
      } catch (error) {
        toast.error('Something went wrong! Please try again.');
      }
    }    
  });

  useEffect(() => {
    const getCountryCode = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        const country = data.country_code;

        setCountryCode(country);

      } catch (error) {
        // toast.error("Error fetching country code", error);
      }
    };

    getCountryCode();
  }, []);


  return (
    <> 
      <ToastContainer position="top-right" autoClose={3000} />
      <section className="home-section" id="home">
        <div className="home-section-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-7 padding-top-70">
              <h1>We Build Amazing Applications For Your Business, Instantly</h1>
              <p>Allow us to build your App, while you focus on your business.</p>
              <ul className="home-benefits">
                <li><i className="fas fa-check-circle"></i>Leading provider of comprehensive web and mobile app solutions.</li>
                <li><i className="fas fa-check-circle"></i>Specializing in creating engaging and user-centric digital experiences.</li>
                <li><i className="fas fa-check-circle"></i>Dedicated to driving business growth through innovative technology solutions.</li>
              </ul>
              <a href="#pricing" className="btn-blue scrool">Get Started</a>
            </div>

            <div className="col-md-5">
              <div className="register-form-wrapper wow bounceIn" data-wow-delay="0.05s">
                <h3>Request Demo</h3>
                <form id="request-form" className="register-form register" onSubmit={handleSubmit}>

                  <div className="input-margin">
                    <input
                      className="register-input white-input"
                      name="businessName"
                      value={values.businessName}
                      placeholder="Business Name *"
                      type="text"
                      onChange={handleChange}
                    />
                    {touched.businessName && errors.businessName && <span className='text-danger'>{errors.businessName}</span>}
                  </div>

                  <div className="input-margin">
                    <select
                      className="register-input white-input"
                      name="businessType"
                      value={values.businessType}
                      onChange={handleChange}
                    >
                      <option value="">Select Business Type</option>
                      <option value="Resale">Retail</option>
                      <option value="Restaurant">Restaurant</option>
                    </select>
                    {touched.businessType && errors.businessType && <span className='text-danger'>{errors.businessType}</span>}
                  </div>

                  <div className="input-margin">
                    <input
                      className="register-input white-input"
                      name="businessEmail"
                      value={values.businessEmail}
                      placeholder="Email Address *"
                      type="email"
                      onChange={handleChange}
                    />
                    {touched.businessEmail && errors.businessEmail && <span className='text-danger'>{errors.businessEmail}</span>}
                  </div>


                  <div className="input-margin">
                    <PhoneInput
                      country={countryCode === 'IN' ? 'in' : 'us'}
                      preferredCountries={countryCode === 'IN' ? ['in', 'us', 'gb'] : ['us', 'in', 'gb']}
                      value={values.businessPhone}
                      onChange={(phone) => setFieldValue('businessPhone', phone)}
                      inputStyle={{
                        width: '100%',
                        fontSize: '16px',
                        height: '52px',
                        color: '#656565',
                        border: '1px solid #ededed',
                        backgroundColor: '#f7f8f9',
                      }}
                      containerStyle={{
                        marginBottom: '10px',
                      }}
                      dropdownStyle={{
                        position: 'absolute',
                        left: '0',
                        zIndex: 10,
                      }}
                    />
                    {touched.businessPhone && errors.businessPhone && <span className='text-danger'>{errors.businessPhone}</span>}
                  </div>

                  <div className="input-margin">

                    <input
                      className="register-input white-input"
                      placeholder="Anything else you'd like us to know?"
                      name="description"
                      value={values.description}
                      type="text"
                      onChange={handleChange}
                    />

                  </div>

                  <div className="input-margin">
                    <input
                      type="submit"
                      className="register-submit"
                      id="submit-button"
                      disabled={isSubmitting}
                      value={isSubmitting ? 'Submitting...' : 'Submit'}
                    />
                    {isSubmitting && <span id="submit-spinner" className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AboutUs />
      <ProductSection />
      <NewsletterAndFeaturesSection />
      <PricingSection />
      <PartnersSection />
      <FeaturesSection />
      <FAQSections />
      <LiveApplicationsCarousel />
      <ContactSection countryCode={countryCode} />

    </>
  );
}
